import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import Navigation from "../Navigation/Navigation";
import ROUTE_CONSTANTS from "../routes/ROUTE_CONSTANTS";

import HomePage from "./home/HomePage";
import VideosPage from "./videos/VideosPage";
import PicsPage from "./pics/PicsPage";
import CalendarPage from "./calendar/CalendarPage";
import AboutPage from "./about/AboutPage";
import ContactPage from "./contact/ContactPage";

import MusicPage from "./music/MusicPage";
import NortonMusicPage from "./music/norton-think-about-nothing/NortonMusicPage";
import IWillTellYouMusicPage from "./music/i-will-tell-you/IWillTellYouMusicPage";
import ChristmasSongsOnBassGuitarPage from "./music/christmas-songs-on-bass-guitar/ChristmasSongsOnBassGuitarPage";

const Routes = () => (
  <Router>
    <div>
      <Navigation />

      <hr />

      <Route exact path={ROUTE_CONSTANTS.HOME} component={HomePage} />
      <Route path={ROUTE_CONSTANTS.VIDEOS} component={VideosPage} />
      <Route path={ROUTE_CONSTANTS.PICS} component={PicsPage} />
      <Route path={ROUTE_CONSTANTS.CALENDAR} component={CalendarPage} />
      <Route path={ROUTE_CONSTANTS.ABOUT} component={AboutPage} />
      <Route path={ROUTE_CONSTANTS.CONTACT} component={ContactPage} />
      <Route path={ROUTE_CONSTANTS.MUSIC} component={MusicPage} />
      <Route path={ROUTE_CONSTANTS.MUSIC_NORTON} component={NortonMusicPage} />
      <Route
        path={ROUTE_CONSTANTS.MUSIC_I_WILL_TELL_YOU}
        component={IWillTellYouMusicPage}
      />
      <Route
        path={ROUTE_CONSTANTS.MUSIC_CHRISTMAS_SONGS_ON_BASS_GUITAR}
        component={ChristmasSongsOnBassGuitarPage}
      />

      <hr />
    </div>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/Routes.js